export default "__VITE_ASSET__60d5cae1__"